import * as actions from './actions';
import * as getters from './getters';
import { FETCH_LOCATIONS_LIST } from '../../mutation-types';


const mutations = {
  [FETCH_LOCATIONS_LIST](state, payload) {
    state.locationsList = payload
  },
};

const state = {
  locationsList: null,
  url: '/v1/locations'
};

export default {
  namespaced: true,
  mutations,
  actions,
  getters,
  state,
};
